import type { IntegratedModuleId } from "./config";

/** Chemins cibles dans les modules intégrés (handoff). */
export const MODULE_TARGET_PATHS = {
  rh: {
    employees: "/tenant/employees?embed=1",
    departments: "/tenant/departments?embed=1",
    schedules: "/tenant/schedules?embed=1",
  },
  inventory: {
    scan: "/tenant/inventory/integrations/barcode?embed=1",
    articles: "/tenant/inventory/articles?embed=1",
    stockLevels: "/tenant/inventory/stock?embed=1",
    receipts: "/tenant/inventory/stock/receipts?embed=1",
    issues: "/tenant/inventory/stock/issues",
    movements: "/tenant/inventory/movements",
    warehouses: "/tenant/inventory/warehouses",
  },
  billing: {
    customers: "/tenant/billing/customers?embed=1",
    products: "/tenant/billing/products?embed=1",
    invoices: "/tenant/billing/invoices?embed=1",
    payments: "/tenant/billing/payments?embed=1",
    dashboard: "/tenant/billing?embed=1",
  },
} as const satisfies Record<IntegratedModuleId, Record<string, string>>;
